<template>
  <Modal
    class="transcriber-modal"
    :title="title"
  >
    <div>
      <SourcesDropdown
        v-model="transcriber.source"
        class="input q-mb-lg items-center"
        clearable
        :default-value="{}"
        emit-selected-option
        filled
        hint="Type to search"
        :label="sourceLabel"
        option-label="label"
        :resource="resource"
      />
      <TimezoneRangePicker
        v-model="handleDateRange"
        class="data-range-input"
        date-style="medium"
        hide-button
        :initial-range="transcriber.range"
        show-input
        :timezone="stationTimezone"
      />
    </div>
    <template #buttons="{ close }">
      <a
        class="q-mr-md text-black"
        href="#"
        @click.prevent="close"
      >
        Cancel
      </a>
      <QBtn
        class="no-shadow bg-primary bold q-py-smd text-white"
        :disabled="!transcriber.source"
        label="Transcribe"
        @click="save"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";
import TimezoneRangePicker from "shared/components/core/pickers/TimezoneRangePicker.vue";
import DateRange from "shared/helpers/DateRange";

import SourcesDropdown from "src/components/common/SourcesDropdown.vue";

export default {
  name: "AutoTranscribeModal",
  components: {
    TimezoneRangePicker,
    Modal,
    SourcesDropdown,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  emits: ["save"],
  data() {
    return {
      transcriber: {
        source: null,
        range: DateRange.today(),
      },
    };
  },
  computed: {
    isRadio() {
      return this.type === "radio";
    },
    resource() {
      return this.isRadio ? "radioStation" : "tvChannel";
    },
    sourceLabel() {
      return this.isRadio ? "Station" : "Channel";
    },
    title() {
      return this.isRadio ? "Transcribe Radio Clips" : "Transcribe TV Clips";
    },
    handleDateRange: {
      get() {
        return this.transcriber.range;
      },
      set(val) {
        this.transcriber.range = val;
      },
    },
    stationTimezone() {
      if (!this.transcriber.source) {
        return null;
      }

      return (
        this.transcriber.source.timeZone || this.transcriber.source.time_zone
      );
    },
  },
  methods: {
    save() {
      if (this.transcriber.range.span > 10800) {
        this.$q.notify({
          message: "Please select a duration less that 3 hours",
          color: "error",
          position: "bottom",
          closeBtn: "Dismiss",
        });
      } else {
        const type = this.isRadio ? "Radio" : "TV";

        this.$dialog({
          theme: "danger",
          title: "Are you sure?",
          message: `${type} content will be sent to voice-to-text service for transcription`,
          persistent: true,
          confirmLabel: "Proceed",
        }).onOk(() => {
          this.$emit("save", this.transcriber);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.transcriber-modal {
  z-index: 1500 !important;
}
</style>
